export const environment = {
    production: true,
    name: 'Staging',
    apiUrl: 'https://jobs-sta.chapps.com/'
  };